.table-style{width:100%}.table-align-text{text-align:left!important}.client-information-vertical-layout{margin-top:30px;margin-right:30px}
/*# sourceMappingURL=client-information.component-EHKW65CL.css.map */
